const SalesOrder = {
    getSalesOrder:()=>'store/transactions',
  }
  export default SalesOrder